module.exports = __webpack_public_path__ + "assets/fd862d349c49bca3472f6581bd6b0c8e.mp3";